app.controller('CIF3-CTRL', ['$scope', '$window', '$q', '$filter', 'appFactory', '$http',
function ($scope, $window, $q, $filter, appFactory, $http) {

    $scope.CIFInvestor = {}
    $scope.chkquestionfatca = true;
    $scope.chkquestion1 = false;
    $scope.chkquestion2 = false;
    $scope.chkquestion3 = false;
    $scope.chkquestion4 = false;
    //$scope.highrisk = false;

    let tmpdate = new Date();
    tmpdate.setFullYear(tmpdate.getFullYear() - 17);
    $scope.maxDate = new Date().toISOString().slice(0, 10);

    $scope.Rp = 'Rp.';
    var allPromise = $q.all([
           $http({
               method: 'GET',
               url: '/service/client.svc/GetCIFLookup',
           }).then(function (data) {
                $scope.ListLookup = data.data.d;

                if ($scope.ListLookup) {

                    $scope.ListInvestmentObjectives = $filter('filter')($scope.ListLookup, { CIFLookupID: 'InvestmentObjectives' }, true);
                    $scope.ListRisk = $filter('filter')($scope.ListLookup, { CIFLookupID: 'Risk' }, true);
                }
           }, function (error) { }),

        $scope.retrieveSessions()
    ]);

    allPromise.then(function () {

        
        $http({
            method: 'GET',
            url: '/service/client.svc/getCIF',
        }).then(function (data) {

            if (data.data.d != null) {

                //var obj = data.data.d;
                $scope.CIFInvestor = data.data.d;
                $scope.CIFInvestor.Stage = 3;

                console.log("AutoNID", $scope.CIFInvestor.NID);
                if ($scope.CIFInvestor.QuestionRDN == 2) {

                    if (data.data.d.AssetInheritDate)
                        $scope.CIFInvestor.AssetInheritDate = new Date(data.data.d.AssetInheritDate);

                    $http({
                        method: 'GET',
                        url: '/service/client.svc/GetRiskPermata?CIFNID=' + $scope.CIFInvestor.NID,
                    }).then(function (data) {
                        console.log("b", data);
                        console.log("c", data.data.d.result);
                        if (data.data.d.result == false) {
                            $scope.highrisk = true;
                        } else {
                            $scope.highrisk = false;
                        }
                        console.log("high", $scope.highrisk);
                    }, function (error) { });
                }

                if ($scope.CIFInvestor.QuestionRDN == 1) {
                    $http({
                        method: 'GET',
                        url: '/service/client.svc/AMLChecking?CIFNID=' + $scope.CIFInvestor.NID,
                    }).then(function (data) {
                        console.log("AMLChecking", data);
                        console.log("AMLChecking", data.data.d.result);

                    }, function (error) { });
                }

                if ($scope.CIFInvestor.FATCA1 == 'Ya' || $scope.CIFInvestor.FATCA2 == 'Ya' || $scope.CIFInvestor.FATCA3 == 'Ya')
                    $scope.chkquestionfatca = false;

                if ($scope.CIFInvestor.InvestmentObjectives == 0)
                    $scope.CIFInvestor.InvestmentObjectives = '';

            }
        }, function (error) { });
    });


    $scope.prepareData = function () {

        if ($scope.chkquestion1) {

            if ($scope.chkquestion1 = true) {

                $scope.CIFInvestor.Question1 = 'Ya';
                $scope.CIFInvestor.Question1_Text = '';
            }
        }

        if ($scope.chkquestion2) {

            if ($scope.chkquestion2 = true) {

                $scope.CIFInvestor.Question2 = 'Ya';
                $scope.CIFInvestor.Question2_Text = '';
            }
        }

        if ($scope.chkquestion3) {

            if ($scope.chkquestion1 = true) {

                $scope.CIFInvestor.Question3 = 'Ya';
                $scope.CIFInvestor.Question3_Text = '';
            }
        }

        if ($scope.chkquestion4) {

            if ($scope.chkquestion4 = true) {

                $scope.CIFInvestor.Question4 = 'Ya';
                $scope.CIFInvestor.Question4_Text = '';
            }
        }

        if ($scope.chkquestion5) {

            if ($scope.chkquestion5 = true) {

                $scope.CIFInvestor.Question5 = 'Ya';
                $scope.CIFInvestor.Question5_Text = '';
            }
        }

        if ($scope.chkquestion6) {

            if ($scope.chkquestion6 = true) {

                $scope.CIFInvestor.Question6 = 'Ya';
                $scope.CIFInvestor.Question6_Text = '';
            }
        }

        if ($scope.chkquestionfatca) {

            if ($scope.chkquestionfatca = true) {

                $scope.CIFInvestor.FATCA1 = 'Tidak';
                $scope.CIFInvestor.FATCA2 = 'Tidak';
                $scope.CIFInvestor.FATCA3 = 'Tidak';
            }
        }

        if ($scope.CIFInvestor.QuestionRDN == 2)
        {
            if (typeof $scope.CIFInvestor.AssetTotalCash == "string") {
                $scope.CIFInvestor.AssetTotalCash = Number($scope.CIFInvestor.AssetTotalCash.replaceAll(".", ""));
            }

            if (typeof $scope.CIFInvestor.AssetTotalInvestment == "string") {
                $scope.CIFInvestor.AssetTotalInvestment = Number($scope.CIFInvestor.AssetTotalInvestment.replaceAll(".", ""));
            }

            if (typeof $scope.CIFInvestor.AssetTotalProperty == "string") {
                $scope.CIFInvestor.AssetTotalProperty = Number($scope.CIFInvestor.AssetTotalProperty.replaceAll(".", ""));
            }

            if (typeof $scope.CIFInvestor.AssetTotalOther == "string") {
                $scope.CIFInvestor.AssetTotalOther = Number($scope.CIFInvestor.AssetTotalOther.replaceAll(".", ""));
            }

            if (typeof $scope.CIFInvestor.AssetTotalLegacy == "string") {
                $scope.CIFInvestor.AssetTotalLegacy = Number($scope.CIFInvestor.AssetTotalLegacy.replaceAll(".", ""));
            }

            if (typeof $scope.CIFInvestor.JobStockBusinessInv == "string") {
                $scope.CIFInvestor.JobStockBusinessInv = Number($scope.CIFInvestor.JobStockBusinessInv.replaceAll(".", ""));
            }

            if (typeof $scope.CIFInvestor.JobIncomeBonus == "string") {
                $scope.CIFInvestor.JobIncomeBonus = Number($scope.CIFInvestor.JobIncomeBonus.replaceAll(".", ""));
            }

            if (typeof $scope.CIFInvestor.JobPension == "string") {
                $scope.CIFInvestor.JobPension = Number($scope.CIFInvestor.JobPension.replaceAll(".", ""));
            }

            if (typeof $scope.CIFInvestor.BzOwnershipPct == "string") {
                $scope.CIFInvestor.BzOwnershipPct = Number($scope.CIFInvestor.BzOwnershipPct.replaceAll(".", ""));
            }

            if (typeof $scope.CIFInvestor.BzProfitLoss == "string") {
                $scope.CIFInvestor.BzProfitLoss = Number($scope.CIFInvestor.BzProfitLoss.replaceAll(".", ""));
            }

            if (typeof $scope.CIFInvestor.BzTotalEmployee == "string") {
                $scope.CIFInvestor.BzTotalEmployee = Number($scope.CIFInvestor.BzTotalEmployee.replaceAll(".", ""));
            }

            if (typeof $scope.CIFInvestor.ProfIncome == "string") {
                $scope.CIFInvestor.ProfIncome = Number($scope.CIFInvestor.ProfIncome.replaceAll(".", ""));
            }

            if (typeof $scope.CIFInvestor.InvestTotalYear == "string") {
                $scope.CIFInvestor.InvestTotalYear = Number($scope.CIFInvestor.InvestTotalYear.replaceAll(".", ""));
            }
        }
       
    }

    $scope.submit = function () {
        $scope.prepareData();

        // dynamic sweet alert post to app.js
        // 1: set the url of post or get request
        // 2: set the sweet alert translation, refers to apps.js $scope.SWALtranslate() :preconfirm = confirmation dialog before post or get request
        // 3: set the postdata to $http request = GET : {} / POST { yourdata : data }
        // 4: set the method to $http request = "GET" / "POST"
        // 5: set the sweet alert translation, refers to apps.js $scope.SWALtranslate() :preconfirm = confirmation dialog before post or get request
        // 6: if success or no error returns then...
        var urlsvc = '/service/client.svc/SaveCIF'; // 1
        var postData = { cifdata: $scope.CIFInvestor } // 2
        var preconfirmtranslate = "submitCif3"; // 3
        var method = "POST" // 4
        $scope.PostGetSwal(preconfirmtranslate, urlsvc, postData, method, function (issuccess) {

            if (issuccess) // 6
                $window.location.href = "#/cif/data-pernyataan";
        });
    }

    $scope.validationinput = function () {

        var errorForm = $scope.myForm.$error.required
        var validation = $scope.myForm.$valid;
        var message = [];
        //console.log('error :', errorForm);

        if (errorForm) {
            for (let i = 0; i < errorForm.length; i++) {
                //message += errorForm[i].$name + " , ";
                message.push(errorForm[i].$name);
            }
        }

        //PROSES VALIDATION
        if (validation == false) {
            console.log("error : " + message);

            var SWALtranslate = $scope.SWALtranslate('validationinput');
            Swal.fire({
                title: SWALtranslate.title,
                text: SWALtranslate.message,
                imageUrl: 'img/collection/wrong.png',
                imageAlt: 'Preparation',
                imageHeight: 250,
                animation: false
            });
        }
    }
}]);


